import { StyledRootLoadingSpinner } from './RootLoadingSpinner.styles';
import { Spinner } from './Spinner';

export const RootLoadingSpinner = () => {
  return (
    <StyledRootLoadingSpinner data-testid="root-loading-spinner">
      <Spinner />
    </StyledRootLoadingSpinner>
  );
};
